import { FsDir } from "./fsentry";

import { FS } from "./fs";
import type { TestFilesConfig } from "./fs";
import type { Writable } from "svelte/store";
import { sleep } from "./util";
import { split } from "./filepath";
import { testFiles } from "./testfiles";

class FileSystemTest extends FS {
  constructor(config: TestFilesConfig) {
    super(config);
  }

  async readDir(dirPath: string, force: boolean, progress: Writable<any>) {
    let e = this.dirs.get(dirPath);
    if (!e) {
      throw new Error("no entries");
    }
    return e;
  }

  async deleteOne(path: string) {
    // TODO: implement me
  }

  async deleteFiles(paths: string[], progress: Writable<any>) {
    progress.set(`deleting files`);
    await sleep(1000);
    for (let p of paths) {
      await this.deleteOne(p);
    }
  }
}

export function makeFileSystemTest(config: TestFilesConfig): FS {
  let flatFiles = testFiles;
  let dirs: Map<string, FsDir> = new Map();
  for (let f of flatFiles) {
    const size = f.size;
    let dn = split(f.name);
    let dirPath = dn.dir;

    if (!dirPath.startsWith("/")) {
      dirPath = "/" + dirPath;
    }
    let de = dirs.get(dirPath);
    if (!de) {
      de = new FsDir(dirPath);
      dirs.set(dirPath, de);
    }
    de.addFile(dn.name, size, 0);
  }
  // add sub-directories
  for (let dirPath of dirs.keys()) {
    console.log(`dirPath: ${dirPath}`);
    if (dirPath == "/") {
      continue;
    }
    let dn = split(dirPath);
    let de = dirs.get(dn.dir);
    if (!de) {
      // TODO: uncomment?
      // de = new FsDir(dn.dir);
      // dirs.set(dn.dir, de);
      continue;
    }
    de.addDir(dn.name);
  }
  let fs = new FileSystemTest(config);
  fs.dirs = dirs;
  return fs;
}
